<template>
  <section id="sbs-371">
    <div class="cs-container">
      <!-- Content Section -->
      <div class="cs-content">
        <span class="cs-topper">Registration</span>
        <h2 class="cs-title">NDIS Registered Provider</h2>
        <p class="cs-text">
          At Ajonee Disability Support Services, we are proud to be an NDIS registered provider, 
          ensuring that individuals with disabilities receive high-quality, 
          government-approved support tailored to their unique needs.
        </p>
        <a href="/contact" class="cs-button-solid">Contact Us</a>
      </div>

      <!-- Image Section -->
      <div class="cs-image-group">
        <picture class="cs-person">
          <source media="(max-width: 600px)" :srcset="imageSrc">
          <source media="(min-width: 601px)" :srcset="imageSrc">
          <img loading="lazy" decoding="async" :src="imageSrc" alt="cleaning" width="586" height="721" aria-hidden="true">
        </picture>
      </div>
    </div>
  </section>
</template>

<script>
export default {
  name: "RegisterationSection",
  data() {
    return {
      imageSrc: require('@/assets/images/IMG_5003.webp') // Ensure image is in src/assets/images/
    };
  }
};
</script>

<style scoped>
/*-- -------------------------- -->
<---   Side By Side Reverse     -->
<--- -------------------------- -*/

/* Mobile - 360px */
@media only screen and (min-width: 0rem) {
#sbs-371 {
    padding: var(--sectionPadding);
    overflow: hidden;
}
@keyframes floatAnimation {
    0% {
        transform: translateY(0);
    }
    50% {
        transform: translateY(-2em);
    }
    100% {
        transform: translateY(0);
    }
}
@keyframes floatAnimation2 {
    0% {
        transform: translateY(0);
    }
    50% {
        transform: translateY(-1em);
    }
    100% {
        transform: translateY(0);
    }
}
#sbs-371 .cs-container {
    width: 100%;
    /* changes to 1280px at desktop */
    max-width: 34.375rem;
    margin: auto;
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;
    /* 48px - 56px */
    gap: clamp(3rem, 3vw, 3.5rem);
}
#sbs-371 .cs-content {
    /* set text align to left if content needs to be left aligned */
    text-align: left;
    width: 100%;
    max-width: 33.875rem;
    display: flex;
    flex-direction: column;
    /* centers content horizontally, set to flex-start to left align */
    align-items: flex-start;
}

#sbs-371 .cs-text {
    margin-bottom: 1rem;
}
#sbs-371 .cs-text:last-of-type {
    margin-bottom: 2rem;
}
#sbs-371 .cs-button-solid {
    font-size: 1rem;
    /* 46px - 56px */
    line-height: clamp(2.875rem, 5.5vw, 3.5rem);
    text-decoration: none;
    font-weight: 700;
    text-align: center;
    margin: 0;
    color: #fff;
    min-width: 9.375rem;
    padding: 0 1.5rem;
    background-color: var(--primary);
    border-radius: 0.25rem;
    display: inline-block;
    position: relative;
    z-index: 1;
    /* prevents padding from adding to the width */
    box-sizing: border-box;
}
#sbs-371 .cs-button-solid:before {
    content: "";
    position: absolute;
    height: 100%;
    width: 0%;
    background: #000;
    opacity: 1;
    top: 0;
    left: 0;
    z-index: -1;
    border-radius: 0.25rem;
    transition: width 0.3s;
}
#sbs-371 .cs-button-solid:hover:before {
    width: 100%;
}
#sbs-371 .cs-image-group {
    /* everything in the group is in ems so we can scale them down with this min/max font size tied to the view width */
    font-size: min(2.3vw, 1em);
    width: 36.1875em;
    height: 20.75em;
    position: relative;
    /* sends it to the top above the content */
    order: -1;
}

#sbs-371 .cs-person {
    width: 24.125em;
    height: auto;
    position: absolute;
    right: 2.875em;
    bottom: 4.0625em;
}
#sbs-371 .cs-person img {
    width: 100%;
    height: auto;
}
}
/* Small Desktop - 1024px */
@media only screen and (min-width: 64rem) {
#sbs-371 .cs-container {
    max-width: 80rem;
    flex-direction: row;
    justify-content: space-between;
    align-items: flex-start;
}
#sbs-371 .cs-ul {
    margin-top: 1rem;
}
#sbs-371 .cs-image-group {
    font-size: min(1.1vw, 1em);
    /* prevents flexbox from squishing it */
    flex: none;
}
}

</style>
